var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 13.4143L6.06058 19.3536C5.86532 19.5489 5.54874 19.5489 5.35348 19.3536L4.64637 18.6465C4.45111 18.4512 4.45111 18.1347 4.64637 17.9394L10.5857 12L4.64637 6.06071C4.45111 5.86545 4.45111 5.54886 4.64637 5.3536L5.35348 4.6465C5.54874 4.45123 5.86532 4.45123 6.06058 4.64649L11.9999 10.5858L17.9393 4.64649C18.1345 4.45123 18.4511 4.45123 18.6464 4.64649L19.3535 5.3536C19.5487 5.54886 19.5487 5.86544 19.3535 6.06071L13.4141 12L19.3535 17.9394C19.5487 18.1346 19.5487 18.4512 19.3535 18.6465L18.6464 19.3536C18.4511 19.5489 18.1345 19.5489 17.9393 19.3536L11.9999 13.4143Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5a44ad622a3a9fb6cc005beaafee8232.svg";
export { ForwardRef as ReactComponent };